// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiDefaultResponseData {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiDefaultResponseData.attributeTypeMap;
    }
}
MedicalV1MedicalBiDefaultResponseData.discriminator = undefined;
MedicalV1MedicalBiDefaultResponseData.additionalProperties = false;
MedicalV1MedicalBiDefaultResponseData.attributeTypeMap = [
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
];
//# sourceMappingURL=medicalV1MedicalBiDefaultResponseData.js.map